const frequentlyBoughtMap = new Map();

export const setFrequentlyBoughtItemsForMenuItem = (menuItemId, relatedIds = []) => {
    if (!menuItemId) return;

    const normalizedIds = Array.isArray(relatedIds)
        ? [...new Set(relatedIds.filter(Boolean))]
        : [];

    frequentlyBoughtMap.set(menuItemId, normalizedIds);
};

export const getFrequentlyBoughtItemsForMenuItem = (menuItemId) => {
    if (!menuItemId) return null;
    return frequentlyBoughtMap.get(menuItemId) || null;
};

export const clearFrequentlyBoughtItemsForMenuItem = (menuItemId) => {
    if (!menuItemId) return;
    frequentlyBoughtMap.delete(menuItemId);
};
